import React from "react";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {
	Input,
	Button,
	Table,
	Modal,
	message,
	Image
} from 'antd';
import 'moment/locale/zh-cn';
import qs from '../../../utils/qs';
//import OrderDetailRequest from '../api/OrderDetailRequest';
//import AddRemarkRequest from '../api/AddRemarkRequest';
import './orderDetail.sass'
import api from "../../../utils/api";

export default class OrderDetail extends React.Component {
	constructor(props) {
		//console.log(props)
		super(props)

		const columns = [
			{
				title: '商品名称',
				dataIndex: 'name',
				key: 'name',
			},
			{
				title: '商品图片',
				// dataIndex: 'entity_img',
				render: (ctx) => {
					//console.log(ctx, )
					return (
						<Image style={{ maxHeight: 50, maxWidth: 50 }} src={ctx['image']} />
					)
				}
			},
			{
				title: '单价',
				dataIndex: 'price',
				key: 'price',
			},
			{
				title: '数量',
				dataIndex: 'num',
				key: 'num',
			},
			// {
			// 	title: '商品状态',
			// 	dataIndex: 'goods_state',
			// 	key: 'goods_state',
			// },
			// {
			// 	title: '退款状态',
			// 	dataIndex: 'goods_refund',
			// 	key: 'goods_refund',
			// },
			{
				title: '实收款',
				dataIndex: 'item_payment_amount',
				key: 'item_payment_amount',
			}
		]

		this.state = {
			order_id: 1 || props.location.state.id,
			detail: null,
			columns: columns,
			dataSource: []
		}
	}

	componentDidMount(props) {
		//console.log(props)
		this.orderDetail()//商家查看订单详情
	}

	orderDetail = async () => {//商家查看订单详情
		//const { order_id } = this.state

		let order_id = qs.hrefParam('id')
		let param = {
			order_id
		}

		let res = await api('get-order', param)
		if (res.status) {
			this.setState({
				detail: res['data']
			})
		}

	}

	cancel = () => {//取消visable
		this.setState({
			remarkVisible: false
		})
	}

	conAddremark = () => {
	}
	render() {
		let { detail, remarkVisible, columns } = this.state;
		const giftColumns = [
			{
				title: '商品名称',
				render: (ctx) => {
					//console.log(ctx, )
					return (
						<p>
							{ctx['goods_name']}
							{Object.values(ctx['spec_name']) ? ':' : ''}
							{Object.values(ctx['spec_name'])}
						</p>
					)
				}
			},
			{
				title: '赠品数量',
				dataIndex: 'buy_quantity',
				key: 'buy_quantity',
			}
		]
		return (
			<div className='orderDetail'>
				{detail ? (
					<div className='detailBox'>
						<div className='line'>
							<div className='title'>基本信息</div>
							<ul className='lineinfo'>
								<li><p>活动标题：</p> {detail.gb.name} </li>
								<li><p>所属供应商：</p>{detail.creator ? detail.creator.name : ''}</li>
								<li><p>所属渠道：</p></li>
								<li><p>所属团长：</p>{detail.provider ? detail.provider.name : ''}</li>
								<li><p>跟团号/昵称：</p>{detail.gb_order_code}</li>
								<li><p>订单编号：</p> {detail.order_code}<CopyToClipboard text={detail.order_code}
									onCopy={() => { message.success('复制成功！') }}><span className='copy'>复制</span></CopyToClipboard></li>
								<li><p>下单时间：</p>{detail.create_time}</li>
								<li><p>订单状态：</p>{qs.orderStatus2(detail.status)}</li>
								<li>
									<p>实付金额：</p>
									<span className='price'>¥{detail.order_payment_amount} </span>
									{/* {
														!detail['need_pay'] ? (
															<span className='copy'>线下支付</span>
														) : null
													} */}
								</li>
							</ul>
						</div>

						<div className='line'>
							<div className='title'>开团商户（团长）信息 </div>
							<ul className='lineinfo'>
								<li><p>自提点：</p>{detail.delivery_address.name}</li>
								<li><p>详细地址：</p>{detail.delivery_address.detail_address}</li>
								<li><p>提货联系人：</p>{detail.delivery_address.consignee_name}</li>
								<li><p>提货电话：</p>{detail.delivery_address.consignee_mobile}</li>
								<li style={{ alignItems: 'flex-start' }}>
									<p>自提点照片：无</p>
									{/* <img className='selfgetpic'></img>
																			<img className='selfgetpic'></img> */}
								</li>
							</ul>
						</div>

						<div className='line'>
							<div className='title'>用户信息 </div>
							<ul className='lineinfo'>
								<li><p>联系人：</p>可乐</li>
								<li><p>联系电话：</p>138****1467</li>
								<li><p>详细地址：</p>蜀山区合欢路中青小区2栋202</li>
								{/* <li><p className='copy'>仅复制收货人信息</p> <p className='copy'>复制商品信息和收货人信息</p></li> */}
							</ul>
						</div>


						<div className='line'>
							<div className='title'>备注</div>
							<ul className='lineinfo'>
								{
									detail.remarks.map(v =>
										<>
											{v.remark_type === 1 && v.remark_detail ? (<li><p>用户备注：</p>{v.remark_detail}</li>) : null}

											{v.remark_type === 2 && v.remark_detail ? (<li><p>团长备注：</p>{v.remark_detail}</li>) : null}

											{v.remark_type === 3 && v.remark_detail ? (<li><p>商户备注：</p>{v.remark_detail}</li>) : null}
										</>
									)
								}
								<li><p onClick={() => this.setState({ remarkVisible: true })} className='copy' style={{ marginLeft: '60px' }}>添加备注</p></li>
								<Modal
									centered
									title='添加备注'
									onCancel={this.cancel}
									visible={remarkVisible}
									footer={false}>
									<div className='flex'>
										<label style={{ display: 'inline-block', lineHeight: '32px', whiteSpace: 'nowrap' }}>
											添加备注：</label>
										<Input style={{ borderRadius: '4px' }}
											onChange={(e) => { this.setState({ merchant_remark: e.target.value }) }}
											placeholder='添加备注' >
										</Input>
									</div>
									<div className='flex' style={{ marginTop: '20px', justifyContent: 'center' }}>
										<Button onClick={this.cancel} style={{ marginRight: '20px' }} className='ant-btn ant-btn-default ant-btn-sm button-bac'>取消</Button>
										<Button onClick={this.conAddremark} className='ant-btn ant-btn-primary ant-btn-sm button-bac'>保存</Button>
									</div>
								</Modal>
							</ul>
						</div>

						<div className='line'>
							<div className='title'>商品信息</div>
						</div>

						<div className="lists" >
							<Table dataSource={
								detail['products']
							}
								loading={false}
								columns={
									columns
								}
								rowClassName={(e, index) => { return index % 2 ? 'gary' : '' }}
								pagination={false}
							/>
						</div>


						{
							detail['gifts'] && detail['gifts'].length ? (
								<>

									<div className='line'>
										<div className='title'>满赠：</div>
									</div>

									<div className="lists" >
										<Table dataSource={
											detail['gifts']
										}
											loading={false}
											columns={
												giftColumns
											}
											rowClassName={(e, index) => { return index % 2 ? 'gary' : '' }}
											pagination={false}
										/>
									</div>
								</>
							) : null
						}


						<div className='line' style={{ overflow: 'hidden' }}>
							<ul className='lineinfo total'>
								<li><p>商品总价：</p>￥2.00</li>
								<li><p>订单总价：</p>￥2.00</li>
								<li><p>优惠券金额：</p>0.00</li>
								<li><p>实付金额：</p> <span style={{ color: '#FD7B35', fontSize: '16px' }}>￥2.00 </span></li>
							</ul>
						</div>


						<div className='line'>
							<div className='title'>售后信息 </div>

						</div>



					</div>
				) : (
					<p>加载数据中</p>
				)}
			</div>
		)
	}
}